import { Pipe, PipeTransform } from '@angular/core';
import { GroupSearchOrder } from '@app-types/enums/GroupSearchOrder';

@Pipe({
  name: 'formatGroupsSearchOrders',
  standalone: true,
})
export class FormatGroupsSearchOrders implements PipeTransform {
  transform(order: string): GroupSearchOrder {
    switch (order) {
      case 'createdAt':
        return GroupSearchOrder.OrderByCreationDateTime;
      case 'name':
        return GroupSearchOrder.OrderByName;
      default:
        return GroupSearchOrder.OrderByGroupId;
    }
  }
}
